import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import { numberAsCurrency } from '../../utils/index';

const MASCOT_URL = 'https://d2zdlj1ifv8u1d.cloudfront.net/images/mascot.png';

const useStyles = makeStyles((theme) => ({
  wrap: {
    marginTop: '8px',
    marginBottom: '16px',
    position: 'relative',
    paddingTop: '44px',
    paddingBottom: '8px',
    backgroundColor: '#275E28',
    borderRadius: '16px',
    overflow: 'hidden',
  },
  mascotWrap: {
    position: 'absolute',
    top: '8px',
    left: '50%',
    transform: 'translateX(-50%)',
    zIndex: 2,
    width: '88px',
    height: '88px',
    borderRadius: '50%',
    overflow: 'hidden',
    border: '4px solid #FFFFFF',
    boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
    backgroundColor: '#FFFFFF',
    '& img': {
      width: '100%',
      height: '100%',
      objectFit: 'cover',
      display: 'block',
    },
  },
  panel: {
    backgroundColor: 'transparent',
    borderRadius: '0',
    padding: '52px 18px 20px',
    color: '#FFFFFF',
    textAlign: 'center',
    boxShadow: 'none',
  },
  successRow: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '10px',
    marginBottom: '10px',
    flexWrap: 'wrap',
  },
  checkIcon: {
    fontSize: '2rem',
    color: '#56F84B',
    fill: '#56F84B',
    flexShrink: 0,
  },
  successTitle: {
    fontWeight: 800,
    fontSize: '1.05rem',
    lineHeight: 1.3,
    textAlign: 'left',
    [theme.breakpoints.down('xs')]: {
      fontSize: '0.95rem',
    },
  },
  subtext: {
    fontSize: '0.95rem',
    fontWeight: 600,
    marginBottom: '18px',
    opacity: 0.95,
  },
  summaryLine: {
    fontSize: '0.9rem',
    marginBottom: '8px',
    color: 'rgba(255,255,255,0.95)',
  },
  lime: {
    color: '#56F84B',
    fontWeight: 800,
  },
}));

export default function OrderSuccessPanel({ order }) {
  const classes = useStyles();
  if (!order) return null;

  return (
    <div className={classes.wrap}>
      <div className={classes.mascotWrap}>
        <img src={MASCOT_URL} alt="" />
      </div>
      <div className={classes.panel}>
        <div className={classes.successRow}>
          <CheckCircleIcon className={classes.checkIcon} />
          <span className={classes.successTitle}>O seu pagamento foi confirmado!</span>
        </div>
        <div className={classes.subtext}>Agora é só torcer!</div>
        <div className={classes.summaryLine}>
          Preço total: <span className={classes.lime}>{numberAsCurrency(order.total_value)}</span>
        </div>
        <div className={classes.summaryLine}>
          Títulos comprados: <span className={classes.lime}>{order.numbers_count}</span>
        </div>
      </div>
    </div>
  );
}
